import React from "react";
import "./Top-Section-Pc.scss";

import { IoPersonOutline } from "react-icons/io5";

import { ReactComponent as NotificationBellIcon } from "../../../assets/icons/notification-bell.svg";

//data imports
import { useSelector } from "react-redux";

const TopSectionPc = () => {
  //data from redux
  const user = useSelector((state) => state.landlordslice);

  return (
    <div className="top-section-pc">
      <div>
        {/* <div className="greeting">
        Hello, <span className="name">Timothy</span>
        </div>
        <div className="notification-text">
          <GoBell size={12} /> 
          <div style={{marginLeft:"2px"}}>
          no notifications at the moment
          </div>
        </div> */}
      </div>
      <div className="profile-and-notifications-container">
        <div className="notifications">
          <NotificationBellIcon size={25} />
          {/* <div className="badge">2</div> */}
        </div>
        <div className="profile-container">
          <div className="notifications">
            <IoPersonOutline size={25} />
          </div>
          <div className="name">{user?.user?.user?.user_name}</div>
        </div>
      </div>
    </div>
  );
};

export default TopSectionPc;
